import { render, staticRenderFns } from "./AdministratorsAddRoleModal.vue?vue&type=template&id=25728d19&scoped=true"
import script from "./AdministratorsAddRoleModal.vue?vue&type=script&lang=js"
export * from "./AdministratorsAddRoleModal.vue?vue&type=script&lang=js"
import style0 from "./AdministratorsAddRoleModal.vue?vue&type=style&index=0&id=25728d19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25728d19",
  null
  
)

export default component.exports